/*!
 * @license
 * Copyright 2019 Alfresco Software, Ltd.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import packageJson from '../../../../../../package.json';
import { AppStore, getUserProfile } from '@alfresco/aca-shared/store';
import { ProfileState } from '@alfresco/adf-extensions';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
    selector: 'smt-about-dialog',
    templateUrl: './about.dialog.html',
    styleUrls: ['./about.dialog.scss'],
    host: { class: 'smt-about-dialog' },
    encapsulation: ViewEncapsulation.None
})
export class SMTAboutDialogComponent implements OnInit {

    aldenVersion: string;
    client: string;
    version: string;
    versionDesc: string;

    profile$: Observable<ProfileState>;
    isAdmin: boolean;

    loading: boolean;

    constructor(private store: Store<AppStore>) {
        this.profile$ = this.store.select(getUserProfile);
        
        this.aldenVersion = packageJson['smt-alden-version'];
        this.client = packageJson['smt-client-name'] ?? 'ALDEN';
        this.version = packageJson['smt-client-version'] ?? this.aldenVersion;
        const aldenDesc = packageJson['smt-alden-description'];    
        let versionDesc: string = packageJson['smt-client-version-description'] ?? `BASE${aldenDesc ?? ''}`;
        if(versionDesc) {
            if (!versionDesc.startsWith("("))
                versionDesc = "(" + versionDesc;
            if (!versionDesc.endsWith(")"))
                versionDesc = versionDesc + ")";
            this.versionDesc = versionDesc?.endsWith(this.version) ? versionDesc : `${versionDesc} ${this.version}`;
        }
    }

    ngOnInit(): void {
        this.loading = true;
        this.profile$.subscribe((profile) => {
            if(profile && profile.id) {
                // Solo el usuario admin
                this.isAdmin = profile.isAdmin && (profile.id === "admin" || profile.id === "admin.alden");
                this.loading = false;
            }
        });
    }

}